import React, { useState } from 'react'

const Hero = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    description: ''
  })
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState('')

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)
    setError('')

    try {
      const response = await fetch('https://n8n.srv1012278.hstgr.cloud/webhook/floristeria-lampugnani-dior-send-form', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          full_name: formData.name,
          phone: formData.phone,
          email: formData.email,
          event_description: formData.description
        })
      })

      if (response.ok) {
        window.location.hash = '#thank-you'
      } else {
        throw new Error('Errore durante l\'invio della richiesta')
      }
    } catch (err) {
      setError('Si è verificato un errore durante l\'invio. Riprova più tardi.')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <section className="relative min-h-screen bg-brand-bg flex items-center pt-24 pb-12 lg:pt-0 lg:pb-0">
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?q=80&w=1920&h=1280&auto=format&fit=crop"
          alt="Elegante ristorante con allestimenti verdi"
          className="w-full h-full object-cover opacity-10"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-bg via-brand-bg/80 to-transparent"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-24 items-center">
          <div className="text-center lg:text-left">
            <h1 className="text-5xl md:text-7xl font-serif font-bold text-brand-green mb-6 leading-tight">
              Trasforma il tuo locale in un'oasi verde.
            </h1>
            <p className="text-lg md:text-xl text-brand-text/80 mb-8 max-w-lg mx-auto lg:mx-0">
              Allestimenti e spazi verdi esclusivi per bar, ristoranti e hotel. Creo ambienti eleganti che valorizzano l'esperienza dei tuoi clienti attraverso il potere delle piante.
            </p>
          </div>

          <div className="bg-white p-8 lg:p-10 rounded-lg shadow-xl">
            {isSubmitted ? (
              <div className="text-center py-12 animate-fade-in">
                <h3 className="text-3xl font-serif text-brand-green mb-3">Grazie!</h3>
                <p className="text-brand-text/80">
                  Abbiamo ricevuto la tua richiesta. Ti contatteremo al più presto.
                </p>
              </div>
            ) : (
              <>
                <h2 className="text-3xl font-serif text-brand-green mb-6 text-center">
                  Richiedi un preventivo
                </h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                  <input
                    type="text"
                    name="name"
                    placeholder="Nome e Cognome*"
                    required
                    className="p-3 bg-brand-subtle-bg border border-transparent rounded-md w-full focus:ring-2 focus:ring-brand-green focus:bg-white transition"
                    value={formData.name}
                    onChange={handleInputChange}
                    disabled={isSubmitting}
                  />
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Numero di Telefono*"
                    required
                    className="p-3 bg-brand-subtle-bg border border-transparent rounded-md w-full focus:ring-2 focus:ring-brand-green focus:bg-white transition"
                    value={formData.phone}
                    onChange={handleInputChange}
                    disabled={isSubmitting}
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Email*"
                    required
                    className="p-3 bg-brand-subtle-bg border border-transparent rounded-md w-full focus:ring-2 focus:ring-brand-green focus:bg-white transition"
                    value={formData.email}
                    onChange={handleInputChange}
                    disabled={isSubmitting}
                  />
                  <textarea
                    name="description"
                    placeholder="Descrivi il tuo locale e le tue esigenze*"
                    rows={4}
                    required
                    className="p-3 bg-brand-subtle-bg border border-transparent rounded-md w-full focus:ring-2 focus:ring-brand-green focus:bg-white transition"
                    value={formData.description}
                    onChange={handleInputChange}
                    disabled={isSubmitting}
                  ></textarea>

                  {error && (
                    <p className="text-red-500 text-sm">{error}</p>
                  )}

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full bg-brand-green text-white font-bold py-3 px-6 rounded-md hover:bg-brand-light-green transition-all duration-300 shadow-lg disabled:bg-gray-400 disabled:cursor-not-allowed"
                  >
                    {isSubmitting ? (
                      <div className="flex items-center justify-center">
                        <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Invio in corso...
                      </div>
                    ) : (
                      'Invia la tua Richiesta'
                    )}
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero